import { render, staticRenderFns } from "./NfFlag.vue?vue&type=template&id=741e843a"
import script from "./NfFlag.vue?vue&type=script&lang=js"
export * from "./NfFlag.vue?vue&type=script&lang=js"
import style0 from "./nfCombo.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports